
<template>
    <div class="recommend_horselamp_item">
      <img class="head_img" :src="img !== '' ? img : defaultHeadImg" />
      <div class="xtc_recommend_horselamp_dynamic_desc" v-html="itemDom"></div>
    </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String
    },
    name: {
      type: String
    },
    amount: {
      type: String
    }
  },
  data () {
    return {
      defaultHeadImg: require('../../../../assets/images/xtc/headimg@2x.png')
    }
  },
  computed: {
    itemDom () {
      // const translate = '{{x}} invite a cinco amigos a {{y}}'
      // const translate1 = '{{x}} invite {{y}} a cinco amigos'
      // let translate = '{{x}} invite a cinco amigos a {{y}}'
      const name = this.name || ''
      let translate = this._('FoodC_CGC__name_Mjiz' /** {{name}}获得了{{x}}优惠 */)
      translate = translate.split(' ').join('*')
      let str = ''
      if (name.length > 10) {
        str = translate.replace('{{name}}', '<div class="inviter text over10">' + name + '</div>')
      } else {
        str = translate.replace('{{name}}', '<div class="inviter text">' + name + '</div>')
      }
      str = str.replace('{{x}}', '<div class="amount">' + this.amount + '</div>')
      // return str.replace(/(^(&nbsp;)*)|((&nbsp;)*$)/g, '') // 去掉收尾的&nbsp
      return str.split('*').join('&nbsp;')
    }
  }
}
</script>
<style lang="stylus">
.recommend_horselamp_item .xtc_recommend_horselamp_dynamic_desc {
  .text {
    // font-family: DiDiSansPro-Regular;
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #000000;
    font-weight: 400;
    min-height: 28px;
  }
  .over10 {
    width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .amount {
    width: fit-content;
    // font-family: DiDiSansPro-Medium;
    font-family: Aspira Medium;
    font-size: 28px;
    color: #FF7A45;
    line-height: 28px;
    font-weight: 500;
  }
}
</style>
<style scoped lang="stylus">
.recommend_horselamp_item {
  width: fit-content;
  height: 48px;
  padding-right: 19px;
  margin-bottom: 4px;
  background: rgba(255,255,255,0.75);
  border-radius: 100px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  img {
    width: 40px;
    height: 40px;
    margin: 0 8px 0 4px;
    border-radius: 40px;
  }
  .xtc_recommend_horselamp_dynamic_desc {
    display: flex;
    // font-family: DiDiSansPro-Regular;
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #000000;
    line-height: 28px;
    font-weight: 400;
  }
  .text {
    // font-family: DiDiSansPro-Regular;
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #000000;
    line-height: 28px;
    font-weight: 400;
    flex-wrap: nowrap;
  }
  .inviter {
    width: 60px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .invitee {
    // width: 280px;
    width: fit-content;
  }
  .amount {
    width: 49px;
    margin-right: 18px;
    // font-family: DiDiSansPro-Medium;
    font-family: Aspira Medium;
    font-size: 28px;
    color: #FF7A45;
    line-height: 28px;
    font-weight: 500;
  }
}
</style>